import React, { useState } from 'react';
import { Select, SelectItem } from 'carbon-components-react';

const SelectFormControl = props => {
  const [value, setValue] = useState(
    props.formData === undefined ? '' : props.formData
  );

  const onChange = event => {
    const selected = event.currentTarget.selectedIndex;
    const enumValues = props.schema.enum;
    setValue(enumValues[selected]);
    props.onChange(enumValues[selected]);
  };

  return (
    <Select
      id={props.idSchema.$id}
      className='form-item_select'
      defaultValue={value}
      light
      invalidText='A valid value is required'
      labelText={props.schema.title}
      style={{ width: '100%', minWidth: 200 }}
      onChange={onChange}
    >
      {props.schema.enum.map((option, i) => (
        <SelectItem
          key={`${props.idSchema.$id}-option-${i}`}
          hidden={i === 0}
          disabled={i === 0}
          value={option}
          text={props.schema.enumNames[i]}
        />
      ))}
    </Select>
  );
};

export default SelectFormControl;
